// convert object to form data
export const convertToFormData = (data, removeEmpty = true) => {
  const form = new FormData();
  Object.entries(data).forEach((item) => {
    if (!removeEmpty) {
      form.append(...item);
      return;
    }
    if (
      !checkEmptyValue(item[item.length - 1]) ||
      item[item.length - 1] instanceof File ||
      typeof item[item.length - 1] === "number"
    ) {
      form.append(...item);
    }
  });

  return form;
};

//check empty value
export const checkEmptyValue = (values) => {
  typeof values === "string" && (values = values.trim());
  return values === undefined || values === null || !values.length;
};
